module.exports = __webpack_public_path__ + "img/annual-billing-icon.0b9fb57a.svg";